/* eslint-disable no-return-assign */
import React from 'react';

class Modal extends React.Component {
	componentDidMount() {
		document.addEventListener('mousedown', this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClick, false);
	}

	// this method allows us to capture clicks outside the modal to close it.
	handleClick = (event) => {
		const { clickOutsideToClose } = this.props;
		if (this.node.contains(event.target) || !clickOutsideToClose) {
			return;
		}
		this.handleConfirmationDecision(false);
	};

	handleConfirmationDecision = (confirm) => {
		const { closeModal, handleConfirmation } = this.props;
		if (handleConfirmation) {
			handleConfirmation(confirm);
		}
		closeModal();
	};

	render() {
		const {
			clickOutsideToClose,
			closeModal,
			confirmMsg,
			cancelButtonMsg,
			title,
			modalShouldConfirm,
			size,
			noButton,
			show,
			children,
			customButton,
		} = this.props;

		const hideShowClass = show ? 'd-block' : 'd-none';
		const modalChildren = typeof children === 'string'
			? <span className="d-block my-3 text-center">{children}</span>
			: children;

		return (
			<div
				className={`modal ${hideShowClass}`}
				style={{ background: 'rgba(0,0,0,.6)', overflowY: 'auto' }}
				role="dialog"
				aria-label="modal"
			>
				<div
					className={`modal-dialog modal-dialog-centered mx-auto modal-${size}`}
				>
					<div ref={(node) => (this.node = node)} className="modal-content">
						{title ? (
							<div className="modal-header">
								<h4>{title}</h4>
								{clickOutsideToClose && (
									<button
										type="button"
										className="close"
										aria-label="Close"
										onClick={
											modalShouldConfirm
												? () => this.handleConfirmationDecision(false)
												: closeModal
										}
									>
										<span aria-hidden="true">&times;</span>
									</button>
								)}
							</div>
						) : null}
						<div className="modal-body">
							{!title ? (
								<button
									type="button"
									className="close"
									aria-label="Close"
									onClick={
										modalShouldConfirm
											? () => this.handleConfirmationDecision(false)
											: closeModal
									}
								>
									<span aria-hidden="true">&times;</span>
								</button>
							) : null}
							{/* only mount children if modal is showing. */}
							{show ? modalChildren : null}
							{customButton || null}
							{(noButton || customButton)
								? null
								: (
									<div
										className="d-flex flex-column pt-3 justify-content-center align-items-center"
									>
										<button
											className="btn btn-blue btn-sm"
											type="button"
											aria-label="Ok"
											onClick={() => this.handleConfirmationDecision(true)}
										>
											{confirmMsg || 'Ok'}
										</button>
										{modalShouldConfirm && (
											<button
												type="button"
												className="btn btn-link color-primary btn-sm my-3"
												onClick={() => this.handleConfirmationDecision(false)}
											>
												{cancelButtonMsg || 'Cancel'}
											</button>
										)}
									</div>
								)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Modal;
